<script>
import { StoryPageElementMixin } from "%/dynamic-component-editor/standard-pages/story-page/story-page-element-mixin";
import { FallbackImageElementMixin } from "%/dynamic-component-editor/standard-elements/image-element/fallback-image-element-mixin";
import BaseImageElement
  from "%/dynamic-component-editor/standard-elements/image-element/BaseImageElement.vue";

export default {
  name: "StoryImage",
  extends: BaseImageElement,
  mixins: [StoryPageElementMixin, FallbackImageElementMixin],
  elementPanelSettings: {
    displayName: "Story Thumbnail",
    displayIcon: "image",
    elementType: "element",
    elementGroup: "storyElements",
  },
  computed: {
    imageSrc() {
      return this.entity.thumbnail;
    },
  },
};
</script>
